import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type {
  MedicalStaff,
  MedicalStaffPayload,
} from "@project/types/medical-staff";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/medical-staff`;
const SILENT: RequestConfig = { showNotification: false };

class MedicalStaffService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<MedicalStaff>> => {
    return fetchListPage<MedicalStaff>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<MedicalStaff | undefined> => {
    const data = await get<ApiItemResponse<MedicalStaff> | MedicalStaff>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: MedicalStaffPayload
  ): Promise<MedicalStaff | undefined> => {
    const data = await post<
      ApiItemResponse<MedicalStaff> | MedicalStaff,
      MedicalStaffPayload
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Partial<MedicalStaffPayload>
  ): Promise<MedicalStaff | undefined> => {
    const data = await patch<
      ApiItemResponse<MedicalStaff> | MedicalStaff,
      Partial<MedicalStaffPayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const medicalStaffService = new MedicalStaffService();
